import React from 'react';
import { FaArrowLeft, FaTimes,  } from 'react-icons/fa';
import { Button, Jumbotron, Container} from 'react-bootstrap';
import {BiCabinet} from 'react-icons/bi';
import PropTypes from 'prop-types';
export const ConfirmForm = ({state, setState, onRestart})=>{
	return (
		<Jumbotron fluid>
			<Container>
				<h1 className="display-5 text-center">Are you confirm to create Unclear record for <BiCabinet/> {state.scanText}?</h1>
				<div className="text-center">
					<br/>
					<Button block variant="outline-secondary" className="text-center"
						onClick={()=>{setState(prevState =>{
							return{...prevState , ...{ stage: "SCAN_LOCKER_QR_CODE"}};
						})}}>
						<FaArrowLeft/>Back
					</Button>
					<Button block variant="outline-secondary" className="text-center"
						onClick={onRestart}>
						<FaTimes/>Cancel
					</Button>
					<Button block variant="success" className="text-center"
						onClick={()=>{
							setState(prevState =>{
								return{...prevState , ...{ stage: "UPLOAD_UNCLEAR_DATA"}};
							})
						}}>
						Confirm
					</Button>
					<br/>
				</div>
			</Container>
		</Jumbotron>
	)
}
ConfirmForm.propTypes = {
	state: PropTypes.object,
	setState: PropTypes.func,
	onRestart: PropTypes.func,
};
